import {WritableSignal} from '@angular/core';
import {IValidation, ValidationType} from '@core/api/data-access';
import {ISignCycle} from '@global-data';

import {livenessValidatorTestFactory} from '../logic';
import {IBaseValidationTest} from '../schemas';
import {DocumentVerificationValidationModel, FaceMatchValidationModel, LivenessValidationModel, RegexValidationModel} from './validation-types';

export abstract class ValidationModel implements IValidation {
	abstract ordinal: number;
	abstract type: ValidationType;
	protected constructor(init?: IValidation) {
		Object.assign(this, init);
	}

	abstract isValid(): boolean;
	abstract toJSON(): IValidation; // backend json
	abstract toObject(): IValidation; // state json

	abstract originalInstance: IValidation;

	asRegex(): RegexValidationModel {
		throw new Error('Not implemented');
	}

	asLiveness(): LivenessValidationModel {
		throw new Error('Not implemented');
	}
	asFaceMatch(): FaceMatchValidationModel {
		throw new Error('Not implemented');
	}
	asDocumentVerification(): DocumentVerificationValidationModel {
		throw new Error('Not implemented');
	}

	asValidationTest(signCycleModel$: WritableSignal<ISignCycle>): IBaseValidationTest {
		return livenessValidatorTestFactory(this, signCycleModel$);
	}
}
